/* 
 * Développé par la société Précurseur.
 @copyright  Copyright (c) Précurseur
 @link       https://www.precurseur.fr
 */
import $ from 'jquery';

export default class CarbonReportForm {

    that = this;

    constructor(
        id = 'carbon-report-form'
        ) {

        this.form_id = id;
        this.form = $('#'+id);
        this.init();
        
        //if ($('#carbon-report-form').length) {
        
//        
//        $('#'+this.form_id).on('change', '#carbon_report_category > .radio > label > input', function(e) {
//            console.log(e);
//            //updateForm();
//        });
    };
    
    init = () => {

        var that = this;
        var searchParams = new URLSearchParams(window.location.search);
        var categoryId = searchParams.has("carbon_report_category") ? parseInt(searchParams.get("carbon_report_category")) : null;
        

        $('.surface-tooltip__btn').hover(
            function() {
                $('.surface-tooltip__content').show();
            },
            function() {
                $('.surface-tooltip__content').hide();
            }
        );
        
        $('.carbon-report__btn-category a').each(function(i) {
            var dataCategoryId = parseInt($(this).attr('data-category'));

            if (dataCategoryId == categoryId) {
                $(this).addClass('active');
            }
            
            $(this).on('click',function(e) { 
                e.preventDefault();
                window.location.href = e.delegateTarget.href + '?carbon_report_step=1&carbon_report_category=' + dataCategoryId; 
            })
//
//            e.preventDefault();
//            $(this).find('input').prop("checked", true);
//            that.updateForm();
        });

        /*
        $('#'+this.form_id).on('click', '#carbon_report_category > .radio > label',function(e) { 

            e.preventDefault();
            $(this).find('input').prop("checked", true);
            that.updateForm();
        });
             * 
         */
    };
    
    parseTextToHtml = (text) => {
        var parser = new DOMParser();
        var html = parser.parseFromString(text, 'text/html');

        return html;
    };
    
    updateForm = async (e) => {
        
        var ajaxUrl = $('#carbon_report_save').attr('data-ajaxurl');
        var action = $('#carbon_report_save').attr('data-action');
        var category = $('#carbon_report_category input:checked').val();
        
        const requestBody = {
            'category': category,
            'action': action
        };
        
        $('.carbon-report__form-overlay').addClass('show');
        const updateFormResponse = await this.sendForm(new URLSearchParams(requestBody), ajaxUrl, this.form.attr('method'));
        const html = this.parseTextToHtml(updateFormResponse);
        const form_html = html.getElementById(this.form_id);
        this.form.find('.carbon-report__form-inner').html(form_html.innerHTML);
        $('.carbon-report__form-overlay').removeClass('show');
    };

    sendForm = async (data, url, method) => {
        
        const req = await fetch(url, {
            method: method,
            body: data,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'charset': 'utf-8'
            }
        });

        const text = await req.text();

        return text;
    };
    
};
